import React from 'react';
import { SEOHead } from '../seo/SEOHead';

/**
 * Legacy SEO component - wraps the new SEOHead for backward compatibility.
 * Existing components using <SEO title="" description="" keywords="" /> will continue to work.
 */
export const SEO = ({ title, description, keywords, path, noindex }) => {
  return (
    <SEOHead
      title={title}
      description={description}
      keywords={keywords}
      path={path}
      noindex={noindex}
    />
  );
};

export default SEO;
